<template>
  <div class="container-fluid login-bg">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div class="row">
      <div class="col-lg-6 offset-lg-3">
        <div class="card main-card">
          <div class="card-body">
            <div class="card-text">
              <p class="lead">
                  Login
              </p>
              <div class="alert alert-danger" role="alert" v-if="error">
                {{error}}
              </div>
              <div class="form-group">
                  <label for="email">Email</label>
                  <input type="text" class="form-control" name="email" v-model="email" v-validate="'required|email'" :class="{'has-error': errors.has('email')}" placeholder="Email">
                  <div v-if="errors.has('email')" class="alert alert-danger mt-1">
                    {{ errors.first('email') }}
                  </div>
              </div>
              <div class="form-group">
                  <label for="password">Password</label>
                  <input v-model="password" v-validate="'required|min:8|verify_password'" :class="{'has-error': errors.has('password')}" name="password" type="password" class="form-control" placeholder="Password" ref="password">
                  <div v-if="errors.has('password')" class="alert alert-danger mt-1">
                    {{ errors.first('password') }}
                  </div>
              </div>
              <button v-on:click="login" type="submit" class="btn col-4 vesta-gray-btn">Login</button>

              <router-link :to="{ name: 'ForgotPassword' }" class="forgot-link">Forgot Your Password?</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

.forgot-link {
  margin-top: 1em;
  display: block;
}

.has-error {
  border-color: red;
}


</style>

<script>
/* eslint-disable */
import axios from 'axios'
import Router from 'vue-router'
import {TokenService} from '../../services/token.service'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    data() {
      return {
        serverErrors: [],
        email : '',
        password: '',
        error: '',
        isLoading: false
      }
    },
    components: {
      Loading
    },
    mounted: function() {
       if (!TokenService.getToken()) {
        this.$parent.$emit('noToken', '');
      }
    },
    methods: {
        login: function(e) {
            this.isLoading = true;
            this.error = '';
            const self = this;

            this.$validator
            .validateAll().then(function(passValidation){
              if (passValidation) {
                var reqData = {
                  "username": self.email,
                  "password": self.password,
                  "grant_type": "password"
                };
                axios({
                    method: 'post',
                    url: 'token',
                    data: $.param (reqData),    
                headers: { 
                  "Content-Type": "application/x-www-form-urlencoded"
                }
                }).then(function (response) {
                    TokenService.saveToken(response.data.access_token);
                    TokenService.saveUserName(response.data.userName);

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + TokenService.getToken();

                    // get applicable roles...in this case just admin
                    axios.get('/api/Roles').then(function(response) {
                      if (response.data.status_code === 200 && response.data.results) {
                        if (response.data.results.length === 1) {
                          TokenService.saveRoles(response.data.results[0].Roles);
                        }
                      }
                      
                      self.isLoading = false;

                      self.$parent.$emit('login', '/');
                      self.$router.push({name : 'homeLoggedIn'});
                      // Refresh, so app.vue mounted methods fire again
                      //window.location = window.location.origin;
                    })
                    .catch(function(error){
                      TokenService.removeToken();
                      self.error = 'An error occurred while logging in';
                      self.isLoading = false;
                    });
                })
                .catch(function (error) {
                  TokenService.removeToken();
                  if (error.response && error.response.data["error"] === 'not_approved') {
                    self.error = error.response.data["error_description"];
                  } else {
                    self.error = 'The user name or password is not valid';
                  }
                    
                  self.isLoading = false;
                });
              } else {
                self.isLoading = false;
              }
            })
            .catch(function () {
                self.isLoading = false;
            });
        }
    }
}
</script>